import { FC } from "react";
import { Route } from "react-router-dom";
import { LegacyAwareRouter } from "./LegacyAwareRouter";
import { NotFound } from "../NotFound";
/**
 * Base desktop react routes. When we no longer need the dynamic routing
 * features that pull in angularjs routes, this can be converted to a
 * single static router.
 *
 * Register all react routes here in a `<Route>` component hierarchy. All routes
 * will be nested under a global route that renders the `<WebClientApp>`
 */
const desktopRoutes = [
  <Route path="*" element={<NotFound />} key="notfound" />,
];

export const DesktopRouter: FC = () => (
  <LegacyAwareRouter reactRoutes={desktopRoutes} />
);
